(() => {
  function init(root = document) {
    root.querySelectorAll('[data-avgar-gallery]').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const dialog = gallery.querySelector('dialog');
      let index = 0;
      function show(next) {
        slides[index].querySelectorAll('video').forEach(video => video.pause());
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        gallery.querySelector('[data-gallery-status]').textContent = `Image ${index + 1} of ${slides.length}`;
        gallery.querySelectorAll('[data-gallery-index]').forEach(button => {
          button.setAttribute('aria-pressed', String(Number(button.dataset.galleryIndex) === index));
        });
      }
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
      gallery.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => show(Number(button.dataset.galleryIndex))));
      gallery.querySelector('[data-gallery-open]').addEventListener('click', () => dialog.showModal());
      gallery.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => dialog.querySelectorAll('video').forEach(video => video.pause()));
      gallery.addEventListener('keydown', event => {
        if (dialog.open || !event.target.closest('button')) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
